export enum DeviceTypeModel {
  LG = 'lgwebostv',
  SAMSUNG = 'samsungtizentv',
  WEB = 'mobileweb',
}
